import httpClient from "@/api/httpClient";
import ExtraPage from "@/model/ExtraPage";

function listExtras(): Promise<ExtraPage> {
  return httpClient.getJson<ExtraPage>("/api/extras?page=0&size=100");
}

const extrasApi = {
  listExtras,
};

export default extrasApi;
